// module.exports = null
module.exports = [
  {
    "Purpose Code": "IR002",
    Description: "Family Maintenance",
  },
  {
    "Purpose Code": "IR003",
    Description: "Education-related student expenses",
  },
  {
    "Purpose Code": "IR004",
    Description: "Medical Treatment",
  },
  {
    "Purpose Code": "IR005",
    Description: "Hotel Accommodation",
  },
  {
    "Purpose Code": "IR006",
    Description: "Travel",
  },
  {
    "Purpose Code": "IR007",
    Description: "Utility Bills",
  },
  {
    "Purpose Code": "IR008",
    Description: "Repayment of Loans",
  },
  {
    "Purpose Code": "IR009",
    Description: "Tax Payment",
  },
  {
    "Purpose Code": "IR010",
    Description: "Purchase of Residential Property",
  },
  {
    "Purpose Code": "IR011",
    Description: "Payment of Property Rental",
  },
  {
    "Purpose Code": "IR012",
    Description: "Insurance Premium",
  },
  {
    "Purpose Code": "IR013",
    Description: "Product indemnity insurance",
  },
  {
    "Purpose Code": "IR014",
    Description: "Insurance Claims Payment",
  },
  {
    "Purpose Code": "IR015",
    Description: "Mutual Fund Investment",
  },
  {
    "Purpose Code": "IR016",
    Description: "Investment in Shares",
  },
  {
    "Purpose Code": "IR017",
    Description: "Donations",
  },
  {
    "Purpose Code": "IR01801",
    Description: "Information Service Charges",
  },
  {
    "Purpose Code": "IR01802",
    Description: "Advertising & Public relations-related expenses",
  },
  {
    "Purpose Code": "IR01803",
    Description:
      "Royalty fees, trademark fees, patent fees, and copyright fees",
  },
  {
    "Purpose Code": "IR01804",
    Description:
      "Fees for brokers, front end fee, commitment fee, guarantee fee and custodian fee",
  },
  {
    "Purpose Code": "IR01805",
    Description:
      "Fees for advisors, technical assistance, and academic knowledge, including remuneration for specialists",
  },
  {
    "Purpose Code": "IR01806",
    Description: "Representative office expenses",
  },
  {
    "Purpose Code": "IR01807",
    Description: "Construction costs/expenses",
  },
  {
    "Purpose Code": "IR01808",
    Description: "Transportation fees for goods",
  },
  {
    "Purpose Code": "IR01809",
    Description: "For payment of exported goods",
  },
  {
    "Purpose Code": "IR01810",
    Description: "Delivery fees for goods",
  },
  {
    "Purpose Code": "IR01811",
    Description: "General Goods Trades - Offline trade",
  },
];
